export const EMBED_POST_MESSAGE_SECURITY_KEY = 'pimster-embed';
